/*
 * Copyright (c) 2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import {PackageCategoryEntity} from "types/entities/PackageCategoryEntity";
import {useTranslation} from "react-i18next";
import clsx from "clsx";
import {TicketIcon} from "@heroicons/react/24/outline";
import React, {useState} from "react";
import SellerPackagesEvent from "pages/Front/Booking/Seller/SellerPackagesEvent";
import {PackageCategory} from "types/enums/PackageCategory";
import SellerPackagesAction from "pages/Front/Booking/Seller/SellerPackagesAction";

const SellerPackageItem = (props: {eventPackage: PackageCategoryEntity; notSelected: boolean | null; onClick: () => void; onSelect: () => void}) => {
    const {t} = useTranslation();
    const [isSelected, setIsSelected] = useState(false);

    const getShortNameFromId = (id_string: string) => {
        switch (id_string) {
            case "event_s":
                return "s";
            case "event_l":
                return "l";
            case "event_m":
                return "m";
            case "kinder":
                return "kinder";
            case "school":
                return "school";
            case "ferienpass":
                return "ferienpass";
            default:
                return "s";
        }
    };

    const selectHandler = () => {
        props.onSelect();
    };

    return (
        <li
            className={clsx(
                "SellerPackageItem col-span-1 flex flex-col rounded-lg bg-white shadow",
                props.notSelected === true && "hidden",
                props.notSelected === false && "!col-span-3 !bg-gray-50"
            )}
        >
            <div className="flex w-full items-center justify-between space-x-6 px-3 py-2.5 xl:px-4 xl:py-3 border-b border-gray-300">
                <div className="flex-1">
                    <div className="flex flex-col items-start gap-1">
                        <h3 className="truncate text-xl font-bold text-gray-900">{props.eventPackage.title}</h3>
                        <span className="inline-flex shrink-0 items-center rounded-full bg-green-50 px-1.5 py-0.5 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20">
                            Admin
                        </span>
                    </div>
                </div>
                <div className={"hidden bg-purple-400"} />
                <p className={clsx("size-10 shrink-0 rounded-full flex items-center justify-center uppercase font-bold", "bg-" + props.eventPackage.color)}>
                    {getShortNameFromId(props.eventPackage.id)}
                </p>
            </div>
            {props.eventPackage.categoryInfo && (
                <div className={"flex flex-row w-full py-2.5 xl:py-3"}>
                    <ol className={"grid grid-cols-1 justify-center ml-4 pl-3 xl:pl-4 list-disc marker:text-arbo-red gap-x-3 xl:gap-x-4"}>
                        {props.eventPackage.categoryInfo.infoEventPackage?.values.map((item, index) => {
                            return (
                                <li key={index} className={""}>
                                    {item}
                                </li>
                            );
                        })}
                    </ol>
                </div>
            )}
            {props.notSelected === false && (
                <div className={"px-3 xl:px-4 pb-2.5 lg:pb-3 xl:pb-4"}>
                    {(props.eventPackage.id === PackageCategory.School || props.eventPackage.id == PackageCategory.Kinder) ? (
                        <SellerPackagesAction packageCategory={props.eventPackage.id} />
                    ) : (
                        <SellerPackagesEvent packageCategory={props.eventPackage.id} />
                    )}
                </div>
            )}
            {props.notSelected === null && (
                <div className={"grow flex flex-col justify-end"}>
                    <div className="-mt-px flex divide-x divide-gray-200 border-t border-gray-300  ">
                        <div className="flex w-0 flex-1">
                            <button
                                onClick={selectHandler}
                                className="bg-green-500 hover:bg-green-600 relative -mr-px inline-flex w-0 flex-1 items-center justify-center gap-x-3 rounded-bl-lg border border-transparent py-4 text-sm font-semibold text-white"
                            >
                                <TicketIcon className={"size-5"} />
                                <span>{t("Choose")}</span>
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </li>
    );
};

export default SellerPackageItem;
